import ResetPasswordContainer from "../../../../Component/OtherPages/Authentication/ResetPassword/ResetPassword"

const ResetPasswordPage = () => {
  return (
    <div className='page-body'>
      <ResetPasswordContainer />
    </div>
  )
}

export default ResetPasswordPage